<template>
    <div class="content">
      <h4 class="title">
        Past Invoices
      </h4>
      <ul class="invoice-list">
        <li v-for="invoice in invoices" :key="invoice.id">
          <a :href="invoice.hosted_invoice_url" target="_blank">
            {{ formatDate(invoice) }}
          </a>
        </li>
      </ul>
    </div>
</template>

<script>
import { format } from 'date-fns'
import CompanyApi from '@/api-interface/company'

export default {
  name: 'CompanyInvoices',

  data() {
    return {
      invoices: []
    }
  },

  async created() {
    this.invoices = await CompanyApi.getInvoices({})
  },

  methods: {
    formatDate(invoice) {
      const fromDate = new Date(invoice.period_start * 1000)
      const endDate = new Date(invoice.period_start * 1000)

      return `${format(fromDate, 'YYYY MMMM')} - ${format(endDate, 'YYYY MMMM')}`
    }
  }
}
</script>

<style scoped lang="scss">
.invoice-list {
  overflow: auto;
  height: 400px;
  width: 100%;
  list-style: none;
  padding: 0;
  border-radius: 8px;
  background: #ecedee;
  margin-top: 0;
  margin-left: 0;
  border-color: rgba(34, 36, 38, 0.15);

  li {
    padding: 8px 15px;
    cursor: pointer;
    white-space: normal;
  }
}
</style>
